import React, { Suspense, lazy } from 'react';
import { Hero } from '../components/Hero';
const BelowFold = lazy(() => import('./BelowFold').then(m => ({
  default: m.BelowFold
})));
export function Landing() {
  return <div className="w-full bg-cream-100 font-sans text-forest-800" data-id="element-207" data-mp="3kopmgb4rvckb">
      <Hero data-id="element-208" data-mp="3krk640fyotco" />
      <Suspense fallback={null} data-id="element-209" data-mp="3po29avvn8jmw">
        <BelowFold data-id="element-210" data-mp="3ppdaqp1m9fau" />
      </Suspense>
    </div>;
}